import React from 'react';
import PropTypes from 'prop-types';
import { FDEmptyState, FDStack } from '@facet-wealth/design';
import isDev from 'Helpers/isDev';
import Sentry from 'Integrations/Sentry';
import { Product } from './Product';
import { TaxProduct } from './TaxProduct';

const Products = ({ collection, variant }) => {
  const resources = collection?.resources()?.list();
  const noResources = !resources || resources.length === 0;

  if (noResources && isDev()) {
    throw new Error('This should not be a possible situation');
  } else if (noResources) {
    Sentry.createSentryErrorLog(new Error('No products presented to a member during estate planning setup.'));
  }

  return (
    <FDStack direction={'row'} justifyContent={'center'} alignItems={'flex-start'} spacing={2} wrap>
      {resources.map((resource) => (
        variant === 'tax' // temporary hack to decouple Tax from EP product card until EP product card is redesigned
          ? <TaxProduct
            key={resource.id()}
            resource={resource}
          />
          : <Product
            key={resource.id()}
            resource={resource}
          />
      ))}
      {noResources ? (
        <FDEmptyState
          title={"Something's happened here..."}
          description={'Please reach out to your planner for help'}
        />
      ) : null}
    </FDStack>
  );
};

Products.propTypes = {
  collection: PropTypes.object.isRequired,
  variant: PropTypes.string,
};

Products.defaultProps = {};

export default Products;
